var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueCal',{staticStyle:{"height":"550px","font-family":"'Varela Round', Helvetica, Arial, sans-serif"}})}
var staticRenderFns = []

export { render, staticRenderFns }